import { FC, useEffect } from 'react';
import { getPartnerSettings } from 'utils/partnerSettings';

const FaviconInjector: FC = () => {
  useEffect(() => {
    const settings = getPartnerSettings();
    const element = (document.getElementById('favicon') as HTMLLinkElement) || (document.getElementById('favicon_default') as HTMLLinkElement);
    if (!element || (!settings?.faviconUrl && !settings?.logoUrl)) {
      return;
    }
    element.href = settings.faviconUrl || settings.logoUrl;
  }, []);
  return null;
};

export default FaviconInjector;
